export const USER_DATA = "USER_DATA";
export const WORKSPACE_USER_DATA = "WORKSPACE_USER_DATA";
export const WORKSPACE_ID = "WORKSPACE_ID";
export const PLATFROM_SERVICES = "PLATFROM_SERVICES";
export const FB_ADS_ACCOUNTS = "FB_ADS_ACCOUNTS";
export const IS_REBILLING = "IS_REBILLING";
